/** Import Sass */
import '../../scss/core.scss';
import '../../scss/cirrus.scss';
import '../../scss/dashboard.scss';

export {};

module.hot?.accept();
